/**
 * SectionHeader Component
 * Section header with icon, title, count badge, and optional "View All" link
 */

import React from 'react';

export interface SectionHeaderProps {
  title: string;
  icon?: string;
  count?: number;
  showViewAll?: boolean;
  onViewAll?: () => void;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  icon,
  count,
  showViewAll = false,
  onViewAll,
}) => {
  return (
    <div className="ai360-section-header-enhanced">
      <div className="ai360-section-header-left">
        {icon && (
          <span className="ai360-section-header-icon" role="img" aria-label="section icon">
            {icon}
          </span>
        )}
        <h3 className="ai360-section-header-title">{title}</h3>
        {count !== undefined && count > 0 && (
          <span className="ai360-section-header-count">{count}</span>
        )}
      </div>
      {showViewAll && onViewAll && (
        <button
          className="ai360-section-header-view-all"
          onClick={onViewAll}
          type="button"
        >
          Ver todas →
        </button>
      )}
    </div>
  );
};
